import {
  Action,
  configureStore,
  ThunkAction,
} from '@reduxjs/toolkit';
import accoDetailsReducer from '../features/accoDetails/accoDetailsSlice';

export const store = configureStore({
  reducer: {
    // This is where we add reducers.
    accoDetails: accoDetailsReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
